import classnames from "classnames";
import { SecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import PropTypes from "prop-types";
import React, { useContext, useEffect, useState } from "react";
import LoadingSpinner from "@/components/loading-spinner/LoadingSpinner";
import { getSolutionContactDetails } from "../../utils/data/getContactDetails";
import ContactChat from "../contact-details-box/contact-methods/contact-chat/ContactChat";
import HelpItemDamagedOnDelivery from "../contact-us-delivery-solution/helpItemDamagedOnDelivery/HelpItemDamagedOnDelivery";
import { ContactDetailsContext } from "../../context/contact-details-context";
import SlideIn from "@/components/slide-in/SlideIn";
import ContactDetailsBox from "@/components/contact-details-box/ContactDetailsBox";

import styles from "./contact-us-standard-expanded-solution.module.scss";

function ContactUsStandardExpandedSolution({ solution: { id, hierarchyPosition }, className }) {
  const { liveChatProminenceExperiment } = useContext(ContactDetailsContext);

  const getSolutionComponent = solutionID => {
    switch (solutionID) {
      case "itemDamagedOnDelivery":
        return HelpItemDamagedOnDelivery;
      default:
        return null;
    }
  };
  const [liveChatConfig, setLiveChatConfig] = useState(null);
  const SolutionComponent = getSolutionComponent(id);
  const location = hierarchyPosition.join(" | ");

  useEffect(() => {
    getSolutionContactDetails(location).then(config => {
      setLiveChatConfig(config.chat);
    });
  }, []);

  const contactFields = [
    { name: "email", key: "email" },
    { name: "chat", key: "channel" },
  ];

  return (
    <article className={classnames(styles.standardSolution, className)} data-solution-id={id}>
      <h2 className={styles.standardSolution__top}>Did you know</h2>
      <div className={styles.standardSolution__inner} data-test="solution-inner">
        <SolutionComponent />
        {liveChatProminenceExperiment ? (
          <SlideIn>
            <ContactDetailsBox
              title="We’re here to help"
              fields={contactFields.filter(({ name }) => ["phone", "chat", "email"].includes(name))}
              solutionId={liveChatConfig?.solution}
              location={location}
              otherContactDetails={liveChatConfig?.chat}
              viewContactDetails
              showGreyBackground
              showEmailOption={false}
              showContactDetailsByDefault
            />
          </SlideIn>
        ) : (
          <div className={styles.standardSolution__bottom}>
            <h2>Choose your contact method</h2>
            <div className={styles.contactMethodsContainer}>
              <div className={styles.contactMethodContainer}>
                <span className={styles.contactMethodTitle}>Email us using our webform</span>
                <p className={styles.contactMethodDescription}>
                  We will provide a case number to refer to if you wish to call us (a number will be provided), or if
                  there is no rush, we aim to reply within 24 hours.
                </p>

                <SecondaryButton
                  tag="a"
                  href="/customer-services/email-us?t=deliveryQuery-damagedOnDeliveryNonFurniture-online"
                  role="link"
                >
                  Email us
                </SecondaryButton>
              </div>
              <div className={styles.contactMethodContainer}>
                <span className={styles.contactMethodTitle}>Live chat with John lewis</span>
                {!liveChatConfig && <LoadingSpinner />}
                {liveChatConfig && (
                  <>
                    {liveChatConfig.open && (
                      <>
                        <p>Contact our team via our website. You can save the chat transcript for reference.</p>
                        <div className={styles.liveChatContactMethodOpeningTimes}>
                          <span>7 days a week</span>
                          <span>8am - 9pm</span>
                        </div>
                      </>
                    )}

                    <ContactChat
                      className={styles.liveChatContainer}
                      config={liveChatConfig}
                      location={location}
                      displayOpeningHours={false}
                      displayDescriptionParagraph={false}
                    />
                  </>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </article>
  );
}

ContactUsStandardExpandedSolution.propTypes = {
  solution: PropTypes.shape({
    id: PropTypes.string,
    hierarchyPosition: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  className: PropTypes.string,
};

ContactUsStandardExpandedSolution.defaultProps = {
  className: undefined,
};

export default ContactUsStandardExpandedSolution;
